import React from 'react';
import ReactDom from 'react-dom';
import { isWeiXin, isPCCheck, isIframeAndMobile } from '@utils/tools';
import redirectHandler from '@utils/redirectHandler';
import { definePromiseAllsettled } from '@utils/polyfill';
import { RootStore, RootStoreProvider } from './model';
import Router from './Router/Router';
// 简历Upload用的@ss/mtd-react,全局加载它的样式
import '@ss/mtd-react/lib/upload/style/css';
import './style/index.scss';
// import routes from './Router';
// import App from './App';
// import notFound from './nodes/notFound'

definePromiseAllsettled();

function handleFontSize() {
  // 设置网页字体为默认大小
  (window as any).WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
  // 重写设置网页字体大小的事件
  (window as any).WeixinJSBridge.on('menu:setfont', () => {
    (window as any).WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
  });
}

// 字体大小控制，防止浏览器放大字体导致布局错乱
function controlFontSize() {
  try {
    // 微信环境
    if (isWeiXin()) {
      if (
        typeof (window as any).WeixinJSBridge === 'object' &&
        typeof (window as any).WeixinJSBridge.invoke === 'function'
      ) {
        handleFontSize();
      } else {
        document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
      }
      return;
    }
    // 非微信环境，安卓暂时没有找到控制方法，先通过修改页面内容去适配，ios通过设置body text-size-adjust
    // 参考https://www.cnblogs.com/axl234/p/7753187.html
  } catch (error) {
    console.error(error);
  }
}
const urlSuffix = window.location.pathname;

function replaceLocation(newPath) {
  if (typeof window !== 'undefined' && isPCCheck()) {
    const newUrl = `${window.location.origin}${newPath}${window.location.search}${window.location.hash}`;
    window.location.replace(newUrl);
  }
}

function replaceNotReload(path) {
  if (typeof window !== 'undefined') {
    window.history.replaceState(window.history.state, '', `${window.location.origin}${path}`);
  }
}

// eslint-disable-next-line consistent-return
function reCodeBlock(subject) {
  // 参考https://km.sankuai.com/collabpage/1583306846,需求5和需求6
  // 替换PC或移动端路径前缀
  const newPath = subject === 'web' ? urlSuffix.replace(/^\/m/, '/web') : urlSuffix.replace(/^\/web/, '/m');
  // 如果是https://zhaopin.meituan.com或https://zhaopin.meituan.com/或https://zhaopin.meituan.com/index重定向到https://zhaopin.meituan.com/{m或web}/home
  if (/^\/$/.test(urlSuffix) || /^\/index$/.test(urlSuffix)) return replaceNotReload(`/${subject}/home`);
  // https://zhaopin.meituan.com/mobile 或 https://zhaopin.meituan.com/mobile/ 或 https://career.meituan.com/job-list 跳转 https://zhaopin.meituan.com/m/social
  if (/^.*(\/mobile|mobile\/|\/job-list)$/im.test(urlSuffix)) return replaceNotReload(`/${subject}/social`);
  // 直接修改url链接,不重新跳转
  replaceNotReload(`${newPath}${window.location.search}${window.location.hash}`);
  // PC环境,但是是/m的链接则跳转到/web的链接
  if (subject === 'web' && /^\/m\//.test(urlSuffix)) return replaceLocation(newPath);
  // 非/web/开头或非/m/开头的路径是不正确的路径,跳转到404页面
  if (!/^\/web\//.test(urlSuffix) && !/^\/m\//.test(urlSuffix))
    return window.location.replace(`${window.location.origin}/${subject}/404`);
}

async function renderWithHotReload(RootElement) {
  // 处理微伯乐、微官网、社招伯乐、伯乐门户重定向过来的url上的_token和bg
  const isRedirect = await redirectHandler();
  console.log('isRedirect2', isRedirect);
  // 如果 redirectHandler使用 window.location.replace 或 window.location.href等跳转，这里需要判断结果然后return。避免后面流程继续执行，跳转到PC时_token没有替换成token
  // 如果 redirectHandler使用 使用replaceState则，这里不能return，否则不会展示页面
  // 如果因修改query而跳转了，这里结束后面的流程
  // if (isRedirect) {
  //   return;
  // }

  const isWeiXinEnv = isWeiXin();
  if (isWeiXinEnv) {
    // 标识为微信环境
    document.cookie = 'weixinType=2; path=/; domain=meituan.com;max-age=43200;';
  } else {
    // 标识为手机端浏览器
    document.cookie = 'weixinType=1; path=/; domain=meituan.com;max-age=43200;';
  }
  ReactDom.render(
    <RootStoreProvider rootStore={RootStore}>
      <RootElement />
    </RootStoreProvider>,
    document.getElementById('app'),
  );
  controlFontSize();
}

const middlewareFunc = (RootElement) => {
  if (!isPCCheck()) {
    reCodeBlock('m');
  }
  if (isPCCheck() && !isIframeAndMobile()) {
    reCodeBlock('web');
  }

  return renderWithHotReload(RootElement);
};

middlewareFunc(Router);

// if (/vconsole=true/.test(window.location.search) || /(test|localhost)/i.test(window.location.host)) {
//   // @ts-ignore
//   if (process?.app?.isViteDevMode) {
//     import('vconsole').then(({ default: VConsole }) => {
//       // eslint-disable-next-line no-new
//       new VConsole();
//     });
//   } else {
//     (require as WebpackRequire).ensure(
//       [],
//       () => {
//         const VConsole = require('vconsole');
//         // eslint-disable-next-line no-new
//         new VConsole();
//       },
//       'vconsole',
//     );
//   }
// }

// @ts-ignore
// if(module.hot){
//   // @ts-ignore
//   module.hot.accept('./Router/Router', () => {
//     const router = require('./Router/Router').default;
//     renderWithHotReload(router)
//   })
// }
